// Author thq
// Date 2021-06-25 22:36:47

class EmSppWarehouseMgr {
constructor({
        id = null,
        swmElocName = '',
        swmElocId = '',
        swmSupervisorName = '',
        swmSupervisorId = '',
        swmManagerName = '',
        swmManagerId = '',
        remark = ''}
= {}) {
    this.id = id;
    this.swmElocName = swmElocName;
    this.swmElocId = swmElocId;
    this.swmSupervisorName = swmSupervisorName;
    this.swmSupervisorId = swmSupervisorId;
    this.swmManagerName = swmManagerName;
    this.swmManagerId = swmManagerId;
    this.remark = remark;
}
}

function newEntity() {
return new EmSppWarehouseMgr();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.spareparts.emSppWarehouseMgr.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'swmElocId',
        label: 'label.em.spareparts.emSppWarehouseMgr.grid.swmElocId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'swmElocCode',
        label: 'label.em.spareparts.emSppWarehouseMgr.grid.swmElocCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'swmElocName',
        label: 'label.em.spareparts.emSppWarehouseMgr.grid.swmElocName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'swmSupervisorName',
        label: 'label.em.spareparts.emSppWarehouseMgr.grid.swmSupervisorName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'swmManagerName',
        label: 'label.em.spareparts.emSppWarehouseMgr.grid.swmManagerName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.spareparts.emSppWarehouseMgr.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    swmElocNameFilter : "",
    swmElocIdFilter : "",
    swmSupervisorNameFilter : "",
    swmSupervisorIdFilter : "",
    swmManagerNameFilter : "",
    swmManagerIdFilter : "",
    remarkFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'swmElocNameFilter',
        label: 'label.em.spareparts.emSppWarehouseMgr.filter.swmElocName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emSppLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"swmElocId":"id"}'
                }
        },
        {
        key: 'swmSupervisorNameFilter',
        label: 'label.em.spareparts.emSppWarehouseMgr.filter.swmSupervisorName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"swmSupervisorId":"id"}'
                }
        },
        {
        key: 'swmManagerNameFilter',
        label: 'label.em.spareparts.emSppWarehouseMgr.filter.swmManagerName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"swmManagerId":"id"}'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'swmElocName',
        label: 'label.em.spareparts.emSppWarehouseMgr.entity.swmElocName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emSppLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"swmElocId":"id"}'
                }
        },
        {
        key: 'swmSupervisorName',
        label: 'label.em.spareparts.emSppWarehouseMgr.entity.swmSupervisorName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"swmSupervisorId":"id"}'
                }
        },
        {
        key: 'swmManagerName',
        label: 'label.em.spareparts.emSppWarehouseMgr.entity.swmManagerName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"swmManagerId":"id"}'
                }
        },
        {
        key: 'remark',
        label: 'label.em.spareparts.emSppWarehouseMgr.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmSppWarehouseMgr, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
